import UserOmsIndex from "@/components/oms/users/UserOmsIndex.vue";
import UserOmsAdd from "@/components/oms/users/UserOmsAdd.vue";
import UserOmsDetail from "@/components/oms/users/UserOmsDetail.vue";
import UserOmsEdit from "@/components/oms/users/UserOmsEdit.vue";

let routesUserOmsAccess= [
    {
        path: '',
        meta: {
          title: "List User Access",
        },
        name: "UserOmsIndex",
        component: UserOmsIndex
    },
    {
        path: 'create',
        meta: {
          title: "Create User Access",
        },
        name: "UserOmsAdd",
        component: UserOmsAdd
    },
     
    {
        path: 'detail/:id',
        meta: {
          title: "Detail User Access",
        },
        name: "UserOmsDetail",
        component: UserOmsDetail
    },
     
    {
        path: 'edit/:id',
        meta: {
          title: "Edit User Access",
        },
        name: "UserOmsEdit",
        component: UserOmsEdit
    },
    
]

export default routesUserOmsAccess
  